module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_realseereal_m.1944878fc6e0f1ff53ad2691e9af33bb.png";